import CryptoJS from 'crypto-js'
import customFetchBase from './customFetchBase';
import { createApi } from '@reduxjs/toolkit/query/react';
import { LoginInput } from 'pages/auth/login.page';
import { GenericResponse, IResetPasswordRequest } from './APIInterfaces';
import { IUser } from 'Models/User';
import { loggedUserApi } from './loggedUserApi';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: customFetchBase,
  endpoints: (builder) => ({

    loginUser: builder.mutation<{ access_token: string; status: string }, LoginInput >({
      query(data) {
        return {
          url: 'auth/login',
          method: 'POST',
          body: data,
          credentials: 'include',
        };
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          await dispatch(loggedUserApi.endpoints.getMe.initiate(null));
        } catch (error) {}
      },
    }),
    logoutUser: builder.mutation<void, void>({
      query() {
        return {
          url: 'auth/logout',
          credentials: 'include',
        };
      },
    }),
    verifyEmail: builder.mutation<GenericResponse, string>({
      query(verificationCode) {
        return {
          url: `auth/verifyemail/${verificationCode}`,
          credentials: 'include',
        };
      },
    }),
    forgotPassword: builder.mutation<GenericResponse, { email: string }>({
      query(body) {
        return {
          url: `auth/forgotpassword`,
          method: 'POST',
          credentials: 'include',
          body,
        };
      },
    }),
    resetPassword: builder.mutation<GenericResponse, IResetPasswordRequest>({
      query({ resetToken, password, passwordConfirm }) {
        return {
          url: `auth/resetpassword/${resetToken}`,
          method: 'PATCH',
          body: { password, passwordConfirm },
          credentials: 'include',
        };
      },
    }),
    setPassword: builder.mutation<GenericResponse, { userId: string, password: string } >({
      query({ userId, password }) {
        const jsonToEncrypt = { password, userId };
        const data = CryptoJS.AES.encrypt(JSON.stringify(jsonToEncrypt), 'user password').toString();

        return {
          url: `auth/set-password/${userId}`,
          method: 'PUT',
          body: { password: data },
          credentials: 'include',
        };
      },
    }),
    getUserByVerificationCode: builder.query<IUser, string>({
      query(verificationCode) {
        return {
          url: `auth/` + verificationCode,
          method: 'GET',
          credentials: 'include',
        };
      },
      transformResponse: (results: {status: string, data: IUser}) => results.data,
    }),
    verifyPin: builder.mutation<IUser, string>({
      query(pin) {
        return {
          url: `auth/pin`,
          method: 'POST',
          body: {pin: pin},
          credentials: 'include',
        };
      },
      transformResponse: (results: {status: string, data: IUser}) => results.data,
    }),


  }),
});

export const {
  useLoginUserMutation,
  useLogoutUserMutation,
  useVerifyEmailMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useGetUserByVerificationCodeQuery,
  useVerifyPinMutation,
  useSetPasswordMutation,
} = authApi;
